/** 分层计算频率类型 1 - 单次计算（关闭周期） 2 - 周期调度（开启周期） */
export enum QpsTypeEnum {
  /** 单次计算 */
  single = 1,
  /** 周期调度 */
  cycle = 2,
}

/** 递送周期 */
export enum DeliveryCycleEnum {
  /** 单次 */
  single = 0,
  /** 每小时 */
  hours = 1,
  /** 每天 */
  days = 2,
  /** 每周 */
  weeks = 3,
  /** 每双周 */
  biweekly = 4,
  /** 每月 */
  months = 5,
}

/** 去重规则 */
export enum DuplicateRemovalRadioEnum {
  default = 1,
  day = 2,
}

export interface CycleFormDataType {
  /** 递送周期 */
  qps?: DeliveryCycleEnum;
  /** 按周投递存储周几；按月投递存储几号  */
  sendFrequencyDay?: number;
  /**
   * 递送周期 - 是否对前置周期用户去重后投递
   * @params 0 - 否 1 - 是
   */
  isNoRepetition?: number;
  /**
   * 去重规则
   * @params 1 - 永久 2 - 以天数
   */
  isRemovePermanent?: DuplicateRemovalRadioEnum;
  /** 去重规则 - 以天数 */
  resetMethodDay?: number;
}
